interface ErrorWithStatusCode {
  statusCode: number;
}

export function isErrorWithStatus(
  error: unknown
): error is ErrorWithStatusCode {
  return !!error && typeof error === 'object' && 'statusCode' in error;
}
